import React from "react";
import PropTypes from "prop-types";
// external css
import "../Game.css";
// images
import modalFiks from "icons/modal_fiks.png";
import modalMoyo from "icons/modal_moyo.png";
import modalNeta from "icons/modal_neta.png";

export function GameModal(props) {
  return (
    <div className="modal game_modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content relative">
          <img src={modalFiks} className="modal_fiks" />
          <img src={modalMoyo} className="modal_moyo" />
          <img src={modalNeta} className="modal_neta" />

          <button
            type="button"
            className="btn-close modal_close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={props.onClose}
          ></button>

          <div className="modal-body">
            <h3 className="modal_game_title">Save your game</h3>
            <p className="modal_game_body">
              To save the game, call your parents to
              <br /> enter the Email.
            </p>
          </div>

          <div>
            <input
              type="text"
              placeholder="Enter your Email"
              className="modal_input"
            />
          </div>

          <button className="btn-orange full-width">Save my progress</button>
        </div>
      </div>
    </div>
  );
}

export default GameModal;

GameModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
